/* 🤖 this file was generated by svg-to-ts */
export const matIconForwardToInbox: {
  name: 'forward-to-inbox';
  data: string;
} = {
  name: 'forward-to-inbox',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H4V8l8 5 8-5v5h2V6c0-1.1-.9-2-2-2zm-8 7L4 6h16l-8 5zm7 4 4 4-4 4v-3h-4v-2h4v-3z"/></svg>`
};
